<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>学时统计</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" size="small" :model="formInline" class="user-search">
            <el-form-item label="所属部门：">
                <el-cascader :options="deptTreeList" v-model="formInline.deptId" clearable filterable
                    :show-all-levels="false" :props="{
                        label: 'deptName', value: 'deptId',
                        checkStrictly: true,
                        emitPath: false,
                    }"></el-cascader>
            </el-form-item>
            <el-form-item label="员工号：">
                <el-input size="small" v-model="formInline.workNo" placeholder="请输入员工号"></el-input>
            </el-form-item>
            <el-form-item label="姓名：">
                <el-input size="small" v-model="formInline.userName" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="search()">搜索</el-button>
                <el-button size="small" type="primary" @click="exportData()">导出</el-button>
            </el-form-item>
        </el-form>
        <div class="main-table">
            <my-table :columns="tableForm.customColumns" :tableData="tableForm.tableData" :loading="tableForm.isLoading">
            </my-table>
        </div>
        <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import store from '../../vuex/store';
import { capitalEnglishList, fileDownload, organizationName,downloadFile } from "@/utils/util.js";
import courseApi from '@/api/onlineTraining/classification.js'
import PreviewPapers from '../../components/previewPapers.vue';
import { examStatPage } from '@/api/exam.js'
import { deptTree } from '@/api/dept.js'
import api from '@/api/onlineTraining/studyRec';

export default {
    components: {
        MyTable,
        Pagination,
        myForm,
        PreviewPapers,
    },
    data () {
        return {
            deptTreeList: [],

            formInline: {
                deptId: '',
                workNo: '',
                userName:'',
            },
            tableForm: {
                customColumns: [
                    { label: '所属机构', prop: 'name', formatter: () => { return organizationName } },
                    { label: '员工号', prop: 'workNo' },
                    { label: '姓名', prop: 'userName' },
                    { label: '所属部门', prop: 'deptName' },
                    { label: '计划课程数', prop: 'courseNum' },
                    { label: '计划课程完成数', prop: 'passNum' },
                    { label: '计划课程完成率', prop: 'passRate' },
                    { label: '线上课程学习总时长', prop: 'studyTimesText' },
                    { label: '线下课程学习总学时', prop: 'offlineClassHour' },
                ],
                tableData: [
                ],
                isLoading: false,
            },
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            previewDialog: {
                isPreview: false,
                examId: '',
                visible: false
            },

        }
    },
    created () {
        this.getDictionary();
        this.getData()
    },
    methods: {
        async getDictionary () {
            const deptRes = (await deptTree({ pageNum: 1, pageSize: 999999 })).data;
            this.deptTreeList = deptRes;
        },
        search () {
            this.pageparm.currentPage = 1;
            this.getData();
        },
        async getData () {
            const params = {
                pageNum: this.pageparm.currentPage,
                pageSize: this.pageparm.pageSize,
                ...this.formInline,
            }
            const res = await api.studyTimesStatisticPage(params);
            this.tableForm.tableData = res.data.records;
            this.pageparm.total = res.data.total;
        },
        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize
            this.getData()
        },
        async exportData () {
            downloadFile(await api.studyTimesStatisticPage({
                pageNum: 1,
                pageSize: 99999,
                ...this.formInline
            }, {
                responseType: 'blob',
                isExport: true
            }), 'vnd.openxmlformats-officedocument.spreadsheetml.sheet',`学时统计${new Date().getTime()}`);
        },
    }

}
</script>

<style lang="scss" scoped>
.user-search {
    margin-top: 20px;
}

.option-from {
    font-size: 14px;
    margin-bottom: 10px;
    color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/views/onlineTraining/creditHourStatistics.vue